// TanStack Query keys, in one place so a mutation invalidates exactly what it changed.
export const keys = {
    stations: ['stations'] as const,
    workCenters: ['work-centers'] as const,
    builds: (filter: object) => ['builds', filter] as const,
    allBuilds: ['builds'] as const,
    build: (id: string) => ['build', id] as const,
    documents: (itemId: string, buildId: string | undefined) => ['documents', itemId, buildId ?? null] as const,
    instructionSets: ['instruction-sets'] as const,
    instructionSet: (id: string) => ['instruction-set', id] as const,
    records: (filter: object) => ['records', filter] as const,
    record: (id: string) => ['record', id] as const,
    problems: ['problems'] as const,
    numbers: (days: number) => ['numbers', days] as const,
    syncStatus: ['sync-status'] as const,
};
